<template>
    <ul class="mb-5 px-10 text-[1.125rem]/[1.7]">
        <ClientOnly>
            <li
                v-for="item in items.filter((item) => item !== '\n')"
                :key="item.id"
                class="relative pl-1"
            >
                <span class="slt-flex-center absolute -left-5 top-0 h-[1lh]">
                    <div class="h-2 w-2 rounded-full bg-primary-orange" />
                </span>
                <component :is="{ ...item, type: 'p' }" />
            </li>
        </ClientOnly>
    </ul>
</template>

<script setup>
defineProps({
    items: {
        type: Array,
        required: true,
    },
});
</script>
